export default __webpack_public_path__ + "static/media/Home.b98aea23.png";